module.exports = __webpack_public_path__ + "img/your_wild.f0f8dec8.jpg";